<div id="lista" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
            fxLayout="column" fxLayoutAlign="center center"
            fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- TÍTULO E BOTÃO -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
            <!-- APP TITLE -->
            <div class="logo"
                    fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">
                    group
                </mat-icon>
                <span class="logo-text h1">
                    Grupos de acesso
                </span>
                
                <!-- BOTÃO ADICIONAR -->
                <button mat-mini-fab 
                        color="accent"
                        matTooltip="Adicionar Grupo"
                        (click)="openCadastro()"
                        style="margin-left: 16px;">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
            </div>
        </div>
        <!-- HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <ngx-datatable 
                #table 
                class='material' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'>
                
                <ngx-datatable-column name="Nome" prop="name" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-name="value" ngx-datatable-cell-template>
                        {{name}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                        <button mat-icon-button color="primary" matTooltip="Permissões de acesso" (click)="permissoes(id)">
                            <mat-icon aria-label="Permissões de acesso">lock</mat-icon>
                        </button>

                        <button mat-icon-button color="primary" matTooltip="Alterar" (click)="openAlterar(id)">
                            <mat-icon aria-label="Editar">edit</mat-icon>
                        </button>

                        <button mat-icon-button color="warn" matTooltip="Excluir" (click)="delete(id)">
                            <mat-icon aria-label="Excluir">delete</mat-icon>
                        </button>
                    </ng-template>
                </ngx-datatable-column>
                
            </ngx-datatable>
            <div style="padding: 5px 10px">
                <mat-paginator #paginator [length]="length"
                            [pageSize]="pageSize"
                            [pageSizeOptions]="pageSizeOptions"
                            (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>
